var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('record',{attrs:{"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }